export type CommentsScopeParams = {
  articleId?: number;
  postId?: number;
  chapterId?: string;
  paragraphId?: string;
};

export function getCommentsScopeKey({
  articleId,
  postId,
  chapterId,
  paragraphId,
}: CommentsScopeParams): string {
  if (articleId) {
    return `article:${articleId}`;
  }

  if (postId && chapterId && paragraphId) {
    return `paragraph:${postId}:${chapterId}:${paragraphId}`;
  }

  if (postId && chapterId) {
    return `chapter:${postId}:${chapterId}`;
  }

  if (postId) {
    return `post:${postId}`;
  }

  return 'default';
}
